// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Box, Theme, Typography } from "@outschool/backpack";
import { Container } from "@outschool/ui-legacy-component-library";
import { useLinkComponent } from "@outschool/ui-utils";
import { SystemStyleObject } from "@styled-system/css";
import React from "react";

export type Item = {
  label: string;
  onClick?: () => void;
  trackingUniqueId?: string;
  url?: string;
};

type TagsListProps = {
  fontStyle?: { [key: string]: string | number };
  items: Item[];
  sx?: SystemStyleObject;
  title?: string;
  width?: number;
  onItemClicked?: () => void;
};

export default function TagsList({
  fontStyle,
  items,
  title,
  onItemClicked
}: TagsListProps) {
  const Link = useLinkComponent();
  return (
    <Container sx={{ marginTop: "40px" }}>
      {title && (
        <Typography
          variant="h3"
          sx={(theme: Theme) => ({
            margin: "auto",
            color: "primary.900",
            fontWeight: 500,
            fontSize: `${theme.typography.pxToRem(21)} !important`
          })}
        >
          {title}
        </Typography>
      )}

      <Box
        component="ul"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          listStyle: "none",
          marginTop: "20px"
        }}
      >
        {items.map(item => (
          <Box
            component="li"
            key={item.label}
            sx={{
              margin: "0 12px 12px 0",
              borderRadius: 8,

              "&:hover": {
                boxShadow: "0 2px 5px rgb(37 93 173 / 35%)"
              },

              backgroundColor: "primary.100"
            }}
          >
            <Link
              onClick={() => {
                onItemClicked?.();
                item.onClick;
              }}
              trackingName={"magnet_page_online_classes_links_bottom_topics"}
              trackingUniqueId={item.trackingUniqueId}
              style={{
                color: "#2E3238",
                backgroundColor: "gray6",
                borderRadius: 8,
                padding: "6px 16px",
                display: "block",
                ...fontStyle
              }}
              to={item.url || ""}
            >
              {item.label}
            </Link>
          </Box>
        ))}
      </Box>
    </Container>
  );
}
